import React from 'react';
import EmojiImage from '../../EmojiImage';
import './EmojiPopupContentNoResults.scss';

const EmojiPopupContentNoResults = ({ style, gridSize }: { style?: React.CSSProperties; gridSize: number }) => (
    <div style={style} className="EmojiPopupContentNoResults">
        No emoji found <EmojiImage emojiCode="1F614" size={gridSize * 2.4} />
    </div>
);

export default EmojiPopupContentNoResults;
